import Button from "../../../../components/elements/Button/Button";
import {useIntl} from "react-intl";
import React, {useEffect, useState} from "react";
import {toast} from "react-toastify";
import {selectValueOnFocus} from "../../../../utils/functions";
import axios from "axios";
import errorParser from "../../../../components/ErrorParser/ErrorParser";
import {useOutletContext} from "react-router-dom";

export default function AddProductInTransferForm({
                                                     productsOptions, products, setProducts,
                                                     setShowModalAddProductInTransfer, productIndex,
                                                     sourceAdministration, vats
                                                 }) {

    const intl = useIntl();
    const jwt = localStorage.getItem('jwt')

    const [product, setProduct] = useState(0)
    const [productName, setProductName] = useState('')
    const [qty, setQty] = useState(0)
    const [maxQty, setMaxQty] = useState(0)
    const {context} = useOutletContext()

    useEffect(() => {
        if (productIndex !== null) {
            setProduct(products[productIndex].menu_product_id)
            setProductName(products[productIndex].product_name)
            setQty(products[productIndex].qty)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [productIndex])
    const getData = async (id) => {
        return axios.post(process.env.REACT_APP_API + '/menu-products/stockForAdministration/' + id,
            {administration: sourceAdministration}, {
                headers: {
                    'Authorization': 'Bearer ' + jwt
                }
            })
            .then(async (response) => {
                return response.data.stock
            })
            .catch(err => {
                errorParser(err, intl)
            })
    }
    const addItem = async (e) => {
        e.preventDefault()

        if (product === 0 || qty === 0) {
            toast.error(intl.formatMessage({id: "errors.please_fill_all_fields"}))
            return
        }
        let stock = await getData(product)
        let currentProduct = productsOptions.find((item) => item.administration.id === sourceAdministration && item.menu_product.id === product).menu_product
        let qtyLeft = qty;

        let temp = [...products]
        let currentQty = 0
        let vatPercent = 0
        let vatValue = 0
        let priceValue = 0
        let unitPriceWithVat = 0
        let newProd = {}
        for (let i = 0; i < stock.length; i++) {
            if (qtyLeft > stock[i].left_quantity) {
                currentQty = stock[i].left_quantity
            } else {
                currentQty = qtyLeft
            }


            vatPercent = vats.find(item => item.value === currentProduct.vat).label
            vatValue = parseFloat(stock[i].unit_price * currentQty * vatPercent / 100).toFixed(2)
            priceValue = parseFloat(stock[i].unit_price * currentQty).toFixed(2)
            unitPriceWithVat = parseFloat(stock[i].unit_price * (100 + vatPercent) / 100).toFixed(2)

            newProd = {
                type: currentProduct.type,
                menu_product_id: product,
                product_name: productName,
                unit: currentProduct.unit,
                vat_id: stock[i],
                vat_percent: vatPercent,
                qty: parseFloat(currentQty).toFixed(2),
                unit_price: parseFloat(stock[i].unit_price).toFixed(2),
                value: parseFloat(priceValue).toFixed(2),
                total: parseFloat(parseFloat(priceValue) + parseFloat(vatValue)).toFixed(2),
                vat_value: parseFloat(vatValue).toFixed(2),
                price: currentProduct.type === 'goods' ? parseFloat(stock[i].price).toFixed(2) : 0,
                addition_percent: currentProduct.type === 'goods' ? parseFloat(100 * (parseFloat(stock[i].price) / unitPriceWithVat) - 100).toFixed(2) : 0,
            }
            qtyLeft -= currentQty
            if (productIndex === null) {
                temp.push(newProd)
            } else {
                newProd.product_stock_id = products[productIndex].product_stock_id
                temp[productIndex] = newProd
            }

        }

        context.setContentUpdated(true)
        setProducts(temp)
        setShowModalAddProductInTransfer(false)
    }


    return (
        <>
            <form onSubmit={(e) => addItem(e)}>
                <div className={"content"}>
                    <div className={"row"}>
                        <div className={"col-md-6 col-sm-12"}>
                            <div className={"form-control"}>
                                <div className={"form-label"}>{intl.formatMessage({id: 'nir.product'})}<span
                                    className={"form-required"}>*</span></div>
                                <input type={"text"}
                                       value={productName}
                                       onFocus={selectValueOnFocus}
                                       onChange={(e) => {
                                           context.setContentUpdated(true)
                                           if (isNaN(parseInt(e.target.value))) {
                                               setProductName(e.target.value)
                                           } else {
                                               let currentProd = productsOptions.find((item) => item.administration.id === sourceAdministration && item.menu_product.id === parseInt(e.target.value))
                                               setProductName(currentProd.menu_product.title)
                                               setProduct(currentProd.menu_product.id)
                                               setMaxQty(currentProd.qty)

                                           }
                                       }} required
                                       className={"form-input"}
                                       list="prod_list"
                                />
                                <datalist id="prod_list">
                                    <select>
                                        {
                                            productName.length > 1 && productsOptions.filter((item) =>
                                                item.administration.id === sourceAdministration &&
                                                item.menu_product.title.toLowerCase().includes(productName.toLowerCase())).map((option) => (
                                                <option key={option.value} id={option.menu_product.id}
                                                        label={option.menu_product.title}
                                                        value={option.menu_product.id}/>
                                            ))
                                        }
                                    </select>
                                </datalist>
                            </div>
                        </div>
                        <div className={"col-md-6 col-sm-12"}>
                            <div className={"form-control"}>
                                <div className={"form-label"}>{intl.formatMessage({id: 'general.qty'})}<span
                                    className={"form-required"}>*</span></div>
                                <input type={"number"} step={"0.01"} className={"form-input"} required min={0.01}
                                       onFocus={selectValueOnFocus} max={maxQty}
                                       value={qty} onChange={(e) => {
                                    context.setContentUpdated(true)
                                    setQty(e.target.value)
                                }}/>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"footer"}>
                    <div className={"row"}>
                        <div className={"col-12 d-flex"}>
                            <Button
                                className={"btn-secondary mt-2 ms-auto"}
                                icon={"fa-solid fa-plus"}
                                value={intl.formatMessage({id: 'general.buttons.' + (productIndex === null ? 'add' : 'save')})}
                                type={'submit'}
                            />
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
}

